"use client";
import {
  __async
} from "../chunk-M66XENHI.js";
import { getPortalBaseURL } from "@getpara/core-sdk";
import { handleMessage } from "./worker.js";
const CLEAR_WORKER_TIMEOUT_MS = 1e3 * 90;
let workerInstance;
const resFunctionMap = {};
function removeWorkId(workId, skipClearTimeout) {
  const { timeoutId } = resFunctionMap[workId];
  delete resFunctionMap[workId];
  if (skipClearTimeout) {
    return;
  }
  clearTimeout(timeoutId);
}
function setupWorker(ctx, resFunction, errorFunction, workId, errorContext) {
  return __async(this, null, function* () {
    if (ctx.disableWorkers) {
      const syncWorker = {
        postMessage: function(message) {
          (function() {
            return __async(this, null, function* () {
              try {
                const onmessage = (event) => {
                  resFunction(event.data);
                };
                yield handleMessage({ data: message }, (data) => onmessage({ data }), ctx.disableWorkers);
              } catch (error) {
                errorFunction(error);
              }
            });
          })();
        },
        terminate: () => {
          return;
        }
      };
      return syncWorker;
    }
    const timeoutId = setTimeout(() => {
      removeWorkId(workId, true);
    }, CLEAR_WORKER_TIMEOUT_MS);
    resFunctionMap[workId] = {
      fn: resFunction,
      timeoutId,
      errorFn: errorFunction,
      errorContext: errorContext || {}
    };
    if (ctx.useLocalFiles) {
      throw new Error("useLocalFiles only supported locally");
    } else if (!workerInstance) {
      const workerRes = yield fetch(`${getPortalBaseURL(ctx)}/static/js/mpcWorker-bundle.js`);
      const workerBlob = new Blob([yield workerRes.text()], { type: "application/javascript" });
      const workerScriptURL = URL.createObjectURL(workerBlob);
      workerInstance = new Worker(workerScriptURL);
      const onmessage = (event) => __async(this, null, function* () {
        const { workId: messageWorkId } = event.data;
        delete event.data.workId;
        if (messageWorkId && resFunctionMap[messageWorkId]) {
          yield resFunctionMap[messageWorkId].fn(event.data);
          removeWorkId(messageWorkId);
        }
      });
      workerInstance.onmessage = onmessage;
      workerInstance.onerror = (err) => {
        console.error("worker error:", err);
        Object.keys(resFunctionMap).forEach((id) => {
          if (resFunctionMap[id]) {
            const errorMsg = `worker error with workId ${id} and opts ${JSON.stringify(resFunctionMap[id].errorContext)}: ${err.message}`;
            resFunctionMap[id].errorFn(new Error(errorMsg));
            removeWorkId(id);
          }
        });
        workerInstance == null ? void 0 : workerInstance.terminate();
        workerInstance = void 0;
      };
    }
    return workerInstance;
  });
}
export {
  setupWorker
};
